import { ErrorBoundary } from '@datadog/browser-rum-react';
import { RefreshCcw } from 'lucide-react';
import { useLocation } from 'react-router';

import { AnimatedCard, AppError } from '@components/patterns';

import LayoutLoader from './LayoutLoader';

function LayoutFallback({ error }) {
  const location = useLocation();

  const handleReset = () => {
    window.location = location.pathname;
  };

  if (error.message.includes('Failed to fetch dynamically imported module')) {
    return <LayoutLoader />;
  }

  return (
    <AnimatedCard className="p-5" style={{ maxWidth: 560, margin: '0 auto' }}>
      <AppError
        onRetry={handleReset}
        buttonLabel="Try again"
        buttonIcon={<RefreshCcw />}
      >
        There was an error while loading this page. We’ve been notified and are
        working to get things back to normal quickly.
      </AppError>
    </AnimatedCard>
  );
}

export default function LayoutErrorBoundary({ children }) {
  const location = useLocation();

  return (
    <ErrorBoundary
      key={location.pathname}
      fallback={({ error }) => <LayoutFallback error={error} />}
    >
      {children}
    </ErrorBoundary>
  );
}
